/* eslint-disable no-nested-ternary */
import { FC, useState } from 'react';
import { Icon } from 'common-components';
import classNames from 'classnames';
import styles from './filtersController.module.scss';
import { FiltersControllerProps } from './filtersControllerTypes';
import { useTranslationContext } from '../../contexts/translationContext';

const FiltersController: FC<FiltersControllerProps> = (props: FiltersControllerProps) => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);
    const {
        filtersCount = 0,
        clearCallback,
        onFiltersClick,
        isPrimary = true,
        customTitle = null,
        cx,
        includeAll = true
    } = props;
    const { translate } = useTranslationContext();

    const onClear = (e: any) => {
        e.stopPropagation();
        clearCallback?.();
    };

    const onFiltersClickAction = () => {
        setIsExpanded(!isExpanded);
        onFiltersClick();
    };

    const primaryContent = () => {
        return (
            <>
                <Icon name={'filterAdminGray'} style={{ display: 'flex' }} />
                <span className={styles['primary-title']}>{translate('Filters')}:</span>
                {filtersCount > 0 ? (
                    <span data-testid="filters-controller-info" className={styles.info}>{`(${filtersCount})`}</span>
                ) : (
                    includeAll && <span className={styles['title-button']}>All</span>
                )}
                <Icon name={'rightChevronDark'} style={{ display: 'flex' }} />
            </>
        );
    };

    const secondaryContent = () => {
        return (
            <>
                <Icon name={'filterAdmin'} style={{ display: 'flex' }} />
                <span className={styles.title}>{translate('FilterBy')}</span>
                {filtersCount > 0 && (
                    <>
                        <span data-testid="filters-controller-info" className={styles.info}>{`(${filtersCount})`}</span>
                        {clearCallback && (
                            <span onClick={(e: any) => onClear(e)}>
                                <Icon name={'trashAdmin'} style={{ display: 'flex' }} />
                            </span>
                        )}
                    </>
                )}
            </>
        );
    };

    const customTitleContent = () => {
        return (
            <>
                <Icon name={'filterAdminGray'} style={{ display: 'flex' }} />
                <span className={styles['primary-title']}>{translate(customTitle)}</span>
                {filtersCount > 0 ? (
                    <span data-testid="filters-controller-info" className={styles.info}>{`(${filtersCount})`}</span>
                ) : (
                    includeAll && <span className={styles['title-button']}>All</span>
                )}
                <Icon
                    dataTestid="expand"
                    name={'downArrowIcon'}
                    className={classNames(styles['icon-custom-title'], {
                        [styles['icon-custom-title-expanded']]: isExpanded
                    })}
                />
            </>
        );
    };

    return (
        <div
            data-testid="filters-controller"
            className={classNames(styles['filters-controller'], cx)}
            onClick={onFiltersClickAction}
        >
            {customTitle ? customTitleContent() : isPrimary ? primaryContent() : secondaryContent()}
        </div>
    );
};

export default FiltersController;
